import React from 'react';
import PropTypes from 'prop-types';
import translate from '../translate';
import ProductProp from '../../sections/shop/propTypes/productProp';
import CheckBoxFilledIcon from './CheckBoxFilledIcon';

function FormButton(props) {
  const { t, product } = props;
  const { formAnswerData } = product;
  return formAnswerData ? (
    <button
      className="btn btn-fill-form btn-fill-form-filled"
      type="button"
      data-product={product._id}
    >
      <CheckBoxFilledIcon />
      <span>{t('form.filled')}</span>
    </button>
  ) : (
    <button
      className="btn btn-info btn-fill-form"
      type="button"
      data-product={product._id}
    >
      {t('fill.form')}
    </button>
  );
}

FormButton.propTypes = {
  t: PropTypes.func.isRequired,
  product: PropTypes.shape(ProductProp.propType).isRequired,
};

export default translate(FormButton);
